import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useReviewList } from "../../../../api/inquiries/review/use-review";

import TitlePage from "../../../../components/section/TitlePage/Titlepage";
import Loading from "../../../../components/ui/Loading/Loading";
import { useSetState } from "../../../../utils/hooks";
import { ReviewTable } from "./Section/review-table";
import ReviewFilter from "./Section/ReviewFilter";

export const ReviewBB = () => {
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [submittedFilter, setSubmittedFilter] = React.useState({});
  const [searchBy, setSearchBy] = React.useState("hospitalName");
  const [searchByValue, setSearchByValue] = React.useState("");
  const [sortFilter, setSortFilter] = React.useState({});
  const [isResetted, setIsResetted] = React.useState(false);
  const [isResetting, setIsResetting] = React.useState(false);
  const filters = { ...submittedFilter, ...sortFilter };
  const resettedFilter = { ...sortFilter };
  const { isEmpty, getDataTableProps } = useReviewList(
    isResetted ? resettedFilter : filters,
    sortFilter
  );

  const [mode, setMode] = useState("ALL");
  const toggleMode = (selectedMode) => {
    setMode(selectedMode);
    setSubmittedFilter({ ...selectedFilter, division: selectedMode });
  };

  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };

  const onSubmitFilter = () => {
    setIsResetted(false);
    setSubmittedFilter({
      ...selectedFilter,
      [searchBy]: searchByValue,
    });
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setSubmittedFilter({});
    setSearchByValue("");
    setIsResetting(true);
    setIsResetted(true);
  };

  const onChangeSearchByValue = (value) => {
    setSearchByValue(value);
  };

  useEffect(() => {
    if (selectedFilter?.orderBy !== undefined) {
      setSortFilter({
        orderBy: selectedFilter["orderBy"],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter?.orderBy]);

  useEffect(() => {
    if (isResetting) {
      setTimeout(() => {
        setIsResetting(false);
      }, 500);
    }
  }, [isResetting]);

  return (
    <>
      <div className="mt-8">
        <>
          {isResetting ? (
            <Loading />
          ) : (
            <>
              {isResetted ? (
                <ReviewFilter
                  filter={selectedFilter}
                  onFilter={setSelectedFilter}
                  onSubmitFilter={onSubmitFilter}
                  onResetFilter={onResetFilter}
                  onChangeSearchBy={onChangeSearchBy}
                  onChangeSearchByValue={onChangeSearchByValue}
                />
              ) : (
                <ReviewFilter
                  filter={selectedFilter}
                  onFilter={setSelectedFilter}
                  onSubmitFilter={onSubmitFilter}
                  onResetFilter={onResetFilter}
                  onChangeSearchBy={onChangeSearchBy}
                  onChangeSearchByValue={onChangeSearchByValue}
                />
              )}
            </>
          )}
          <div className="flex mt-8">
            <div
              onClick={() => toggleMode("ALL")}
              className={`cursor-pointer w-[120px] h-8 flex justify-center items-center ${
                mode === "ALL"
                  ? "bg-primary-blue text-white"
                  : "text-[#999999] border border-[#dddddd]"
              } p-[5px]`}
            >
              전체
            </div>
            <div
              onClick={() => toggleMode("PHOTO")}
              className={`cursor-pointer w-[120px] h-8 flex justify-center items-center ${
                mode === "PHOTO"
                  ? "bg-primary-blue text-white"
                  : "text-[#999999] border border-[#dddddd]"
              } p-[5px]`}
            >
              포토 리뷰
            </div>

            <div
              onClick={() => toggleMode("GENERAL")}
              className={`cursor-pointer w-[120px] h-8 flex justify-center items-center ${
                mode === "GENERAL"
                  ? "bg-primary-blue text-white"
                  : "text-[#999999] border border-[#dddddd]"
              } p-[5px]`}
            >
              일반 리뷰
            </div>
          </div>
        </>

        <ReviewTable
          isEmpty={isEmpty}
          getDataTableProps={getDataTableProps}
          onSort={setSortFilter}
        />
      </div>
    </>
  );
};
